import type { Row, Table } from "../Table.types";

import styles from "./InternalTableRow.module.css";

type InternalTableRowExpandedProps<TableData> = {
  row: Row<TableData>;
  tableInstance: Table<TableData>;
  expandableRowId: string;
};

export const InternalTableRowExpanded = <TableData extends {}>(
  props: InternalTableRowExpandedProps<TableData>
) => {
  const { row, tableInstance, expandableRowId } = props;

  const expandedRowChildren = row.originalSubRows?.[0] as React.ReactNode;

  if (!row.getIsExpanded()) {
    return null;
  }

  return (
    <tr>
      <td
        colSpan={tableInstance.getAllColumns().length}
        className={styles.tableRowExpandedCell}
        id={expandableRowId}
      >
        {expandedRowChildren}
      </td>
    </tr>
  );
};
